import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { MobileNavBarTab } from "./mobile-nav-bar-tab";

export const MobileNavBarTabs = ({ handleClick }) => {
    const { isAuthenticated } = useAuth0();

    return (
        <div className="mobile-nav-bar__tabs">
            {isAuthenticated && (
                <>
                    <MobileNavBarTab path="/company" label="Infos entreprise" handleClick={handleClick}/>
                    <MobileNavBarTab path="/cse" label="CSE" handleClick={handleClick}/>
                    <MobileNavBarTab path="/utils" label="Utilisateurs" handleClick={handleClick}/>
                </>
            )}
        </div>
    );
};